export var link = {
    attrs: {
        href: {},
        title: { default: null },
    },
    inclusive: false,
    parseDOM: [
        {
            tag: 'a[href]',
            // @ts-ignore
            getAttrs: function (element) {
                return {
                    href: element.getAttribute('href'),
                    title: element.getAttribute('title'),
                };
            },
        },
    ],
    toDOM: function (node) {
        var _a = node.attrs, href = _a.href, title = _a.title;
        return ['a', { href: href, title: title }, 0];
    },
};
